import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'
import { minimumSearchLength } from 'utils/util'

const path = '/admin/corporate-accounts/licensed-establishments/search'

interface UseGetLicensedEstablishmentSearchParams {
  searchKey?: string
  limit?: number
}

export const useGetLicensedEstablishmentSearch = ({
  searchKey,
  limit,
}: UseGetLicensedEstablishmentSearchParams) => {
  const get = useTypedApiClient({ path, method: 'get' })
  const { currentStateId } = useCurrentStateStore()
  return useQuery({
    enabled: (searchKey?.length ?? 0) >= minimumSearchLength,
    queryKey: [path, searchKey, limit],
    queryFn: async () => {
      const { data } = await get(
        { searchKey, limit },
        currentStateId
          ? { headers: { 'Current-State-Id': currentStateId.toString() } }
          : undefined
      )
      return data
    },
  })
}
